import { memo, useContext, useState } from "react";
import { Context } from "../../../../Context/context";
import { Modal, Button } from "@mui/material";
import { GalleryImage } from "./GalleryImageItem";
import { ImageURLGenerator } from "../../../SketchUtilities/ImageURLGenerator";
import React from "react";
import { baseStyle } from "../../../../theme";
interface Props {
  open: boolean;
  close: () => void;
}

export const ArtThreadGallerySelect = (props: Props) => {
  const { open, close } = props;
  const { state, dispatch } = useContext(Context);
  const baseStyles = baseStyle({});
  const [activeImage, setActiveImage] = useState<string>("");
  const [activeImageID, setActivImageID] = useState<number>(-1000);

  const handleImageSelect = (url: string, index: number) => {
    setActiveImage(url);
    setActivImageID(index);
  };

  const generateGallery = () => {
    if (state.userSessionData && state.userSessionData.images) {
      return state.userSessionData.images.map((url, i) => {
        return (
          <GalleryImage
            key={i}
            isSelected={activeImageID === i}
            index={i}
            handleSelect={handleImageSelect}
            image={url}
          />
        );
      });
    } else {
      return null;
    }
  };

  const fetchTo64 = (
    url: string,
    callback: (image: string | ArrayBuffer | null) => void
  ) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  const saveImage = (url: string) => {
    const imageName = Date.now().toString();
    const formattedURL = ImageURLGenerator(url, "lg");
    try {
      var image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        dispatch({ type: "set_image", value: [imageName, image] });
        dispatch({ type: "set_shape_images", value: imageName });
      };

      image.src = formattedURL as string;
    } catch (e) {}
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="Select Image from Gallery"
        aria-describedby="Select Image from Gallery"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9000000000,
        }}
      >
        <div
          className={baseStyles.modalBase}
          style={{
            width: "70%",
            height: "50%",
            padding: "20px",
          }}
        >
          <div
            style={{
              minHeight: "80%",
              maxHeight: "85%",
              padding: "2%",
              overflowY: "scroll",
            }}
          >
            {generateGallery()}
          </div>
          <div
            style={{ display: "inline-flex", padding: "2%", maxHeight: "10%" }}
          >
            {activeImage !== "" && (
              <div style={{ marginRight: "10px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    saveImage(activeImage);
                    close();
                  }}
                >
                  Add
                </Button>
              </div>
            )}
            <div>
              <Button variant="contained" color="secondary" onClick={close}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default memo(ArtThreadGallerySelect);
